import { BitrixVue } from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore, YA_CAPTCHA_ENABLED } from 'vpl.tas';
import { initYaCaptcha, ymLead } from 'vpl.tas';
import { NewsletterCheckbox } from 'vpl.tas';

export const RequestPage = {
    components: { NewsletterCheckbox },
    props: {
        structKey: [String, Number]
    },
    data(){
        return {
          captcha: false,
          yatoken: ''
        }
      },
    computed: {
        ...mapState(vplSiteStore, ['struct', 'SITE_TEMPLATE_PATH', 'YA_CLIENT_KEY', 'captchaInited', 'templateData'])
    },
    methods: {
        execCaptcha(){
            vplSiteStore.capresolved = true;
            this.sendForm();
        },
        sendForm(){
            let form = $(this.$el).find('form'),
                data = {};

            $.each($("input,textarea,button,select", form), function () {
                if ($(this).attr("type") == "checkbox") {
                    if ($(this).prop("checked")) {
                        data[$(this).attr("name")] = true;
                    }
                } else if ($(this).attr("type") == "radio") {
                    if ($(this).prop("checked")) {
                        data[$(this).attr("name")] = ($(this).hasClass("js-phone") ? $(this).val().replace(/\D/g, "") : $(this).val());
                    }
                } else if (
                    $(this).attr("name") !== undefined &&
                    $(this).attr("name").length
                ) {
                    data[$(this).attr("name")] = ($(this).hasClass("js-phone") ? $(this).val().replace(/\D/g, "") : $(this).val());
                }
            });

            data['WEB_FORM_ID'] = 2;
            data['web_form_submit'] = 'y';
            data['sessid'] = BX.bitrix_sessid();
            data['url'] = window.location.href; //урл для согласия
            data['form_text_29'] = window.location.href; //страница отправки

            data['smart-token'] = this.yatoken;

            if(vplSiteStore.capresolved){
                data['skip-captcha'] = 'Y';
            }

            $.ajax({
                url: '/ajax/form.php',
                method: 'POST',
                data: data,
                success: (response) => {
                    form.find(".is-error").removeClass("is-error");
                    response = JSON.parse(response);

                    if (!response.ERRORS || !Object.keys(response.ERRORS).includes("CAPTCHA")) {
                        vplSiteStore.capresolved = true;
                    }

                    if (response.STATUS == "OK") {
                        ymLead('service_request', response);
                        form.find("input[type=text],input[type=email],textarea").val("");

                        $('#success').modal();

                    } else {
                        for (var i in response.ERRORS) {
                            if (i == "CAPTCHA") {
                                form.find(".captcha").addClass("is-error");
                            } else {
                                form
                                    .find("[name=" + i + "]")
                                    .parent()
                                    .addClass("is-error");
                            }
                        }
                    }
                }
            });
        },
        initCaptcha(){

            let self = this;

            initYaCaptcha();

            let interval = setInterval(()=>{
                if(this.captcha === false &&  (!YA_CAPTCHA_ENABLED || typeof window.smartCaptcha !== "undefined") && this.YA_CLIENT_KEY){

                this.captcha = YA_CAPTCHA_ENABLED && window.smartCaptcha.render($(this.$el).find('.js-captcha')[0], {
                    sitekey: self.YA_CLIENT_KEY,
                    invisible: true,
                    callback: function(token) {
                        window.yaToken = token;
                        self.yatoken = token;
                        self.sendForm();
                    },
                    hideShield: true,
                });

                new Cleave($(this.$el).find('.js-phone')[0], {
                    numericOnly: true,
                    delimiters: [" (", ") ", "-", "-"],
                    blocks: [1, 3, 3, 2, 2]
                });

                clearInterval(interval);
                }
            }, 500);
        }
    },
    updated(){


    },
    mounted(){


        let self = this;
        if(self.captchaInited){
            self.initCaptcha();
        }else{
            const elem = self.$el;
            new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        self.initCaptcha();
                        observer.unobserve(entry.target);
                    }
                });
            }).observe(elem);
        }



        $(this.$el).find('select').show().niceSelect();
    },
    template: `
<section v-if="this.YA_CLIENT_KEY" class="section form-section js-request-page-form">
    <div class="form-section__bg">
        <picture>
            <source type="image/avif" media="(max-width: 768px)" :data-srcset="this.SITE_TEMPLATE_PATH + '/img/content/form-bg-mob.avif'">
            <source type="image/webp" media="(max-width: 768px)" :data-srcset="this.SITE_TEMPLATE_PATH + '/img/content/form-bg-mob.webp'">
            <source media="(max-width: 768px)" :data-srcset="this.SITE_TEMPLATE_PATH + '/img/content/form-bg-mob.png'">
            <source type="image/avif" :data-srcset="this.SITE_TEMPLATE_PATH + '/img/content/form-bg.avif'">
            <source type="image/webp" :data-srcset="this.SITE_TEMPLATE_PATH + '/img/content/form-bg.webp'">
            <img class="lazy" loading="lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="this.SITE_TEMPLATE_PATH + '/img/content/form-bg.png'" alt="" title="">
        </picture>
    </div>
    <div class="container">
        <div class="section__heading">
            <div class="section__title-wp">
                <h2 class="section__title">
					Отправить заявку
                </h2>
            </div>
        </div>
        <form @submit.prevent="execCaptcha()">
            <div class="form__top">
                <div class="form__leftside">
                     <!--
                    <div class="form-select">
                        <select name="form_dropdown_SIMPLE_QUESTION_966" id="" class="sort__select" style="display: none;">
                            <option value="">Выберите услугу</option>
                            <option v-for="answer in this.struct[this.structKey].componentData.SERVICE" :value="answer.ID" class="">{{answer.MESSAGE}}</option>
                        </select>
                    </div>
                    <div class="form-select">
                        <select name="form_dropdown_SIMPLE_QUESTION_418" id="" class="sort__select" style="display: none;">
                            <option value="">Выберите тип объекта</option>
                            <option v-for="answer in this.struct[this.structKey].componentData.OBJECT" :value="answer.ID" class="">{{answer.MESSAGE}}</option>
                        </select>
                    </div>
-->
                    <div class="field js-material-input is-required">
                        <textarea class="field__input field__input--textarea" rows="3" name="form_textarea_9" id="req-text" placeholder="Ваше сообщение" autocomplete="off"></textarea>
                        <span class="field__error-text">Заполнено некорректно.</span>
                    </div>
                </div>
                <div class="form__rightside">
                    <div class="field js-material-input is-required"  :class="{active: templateData.userName}">
                        <input class="field__input" name="form_text_6" id="req-name" autocomplete="off" type="text"  :value="templateData.userName">
                        <label class="field__label" for="req-name">Имя</label>
                        <span class="field__error-text">Заполнено некорректно.</span>
                    </div>
                    <div class="field js-material-input is-required"  :class="{active: templateData.userEmail}">
                        <input class="field__input" name="form_email_7" id="req-mail" autocomplete="off" type="text"  :value="templateData.userEmail">
                        <label class="field__label" for="req-mail">Электронная почта</label>
                        <span class="field__error-text">Заполнено некорректно.</span>
                      </div>
                      <div class="field js-material-input is-required"  :class="{active: templateData.userPhone}">
                        <input class="field__input js-phone" name="form_text_8" id="req-tel" autocomplete="off" type="text"  :value="templateData.userPhone">
                        <label class="field__label" for="req-tel">Телефон</label>
                        <span class="field__error-text">Заполнено некорректно.</span>
                      </div>
                      <div class="form__submit">
                        <div class="form__submit-container">
                            <div class="captcha">
                                <div class="captcha js-captcha">
                                </div>
                            </div>
                              <button type="submit" name="web_form_submit" value="Y" class="btn btn--green">
                                 Отправить
                              </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="checkbox">
                <input type="checkbox" checked name="politic" class="checkbox__input js-politic js-politic-auto" id="politic-req-order">
                <label for="politic-req-order" class="checkbox__label">
                  При нажатии на кнопку «Отправить» вы соглашаетесь с <a href="/politika-konfidentsialnosti/" target="_blank">условиями о сборе персональных данных</a>
                </label>
              </div>
            <NewsletterCheckbox />
		</form>
    </div>
</section>
      `
}